import { marked } from 'marked';

const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
const paragraphRenderer = renderer.paragraph;
const tokenizer = {
  code() {
    // return undefined to prevent indented text from being treated as code block
    // we support code blocks with 3 backticks only
    return undefined;
  },
  url() {
    // Disable automatic link detection and transformation
    // Source: https://github.com/markedjs/marked/issues/882#issuecomment-781585009
    return undefined;
  },
};

renderer.link = (href, title, text) => {
  const mailToLink = href.startsWith('mailto:');
  const localLink = href.startsWith(`${window.location.protocol}//${window.location.hostname}`);
  const html = linkRenderer.call(renderer, href, title, text);

  if (mailToLink) return renderer.text.call(renderer, text); // mailto: links are not allowed

  return localLink ? html : html.replace(/^<a /, '<a target="_blank" rel="noreferrer noopener nofollow" ');
};

renderer.paragraph = (text) => {
  // &gt; on start of a line must be treated as a blockquote removing the &gt; from the text
  // &gt; is the html entity for >, this is sanitized by vue-sanitize to prevent xss
  if (text.startsWith('&gt; ')) {
    return renderer.blockquote(text.replace(/^&gt; /, ''));
  }

  return paragraphRenderer.call(renderer, text);
};

marked.use({
  tokenizer,
  renderer,
});

export default marked;
